<template>
  <div>
    <div class="makbuz" id="Yazdir">
      <div class="header" v-html="data.Bilgi.Makbuz"></div>
      <hr v-if="data.Bilgi.Makbuz">
      <div class="Detay">
        <table class="table">
          <thead>
          <tr>
            <th>Son Ödeme Tarihi</th>
            <th>Borç Türü</th>
            <th>Açıklama</th>
            <th class="text-right">Tutar</th>
            <th class="text-right">Zam</th>
            <th class="text-right">Ödenen</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="Tahakkuk in data.Tahakkuk">
            <td>{{ Tahakkuk.tTarihi }}</td>
            <td>{{ Tahakkuk.Kategori }}</td>
            <td>{{ Tahakkuk.Aciklama }}</td>
            <td class="text-right">{{ Tahakkuk.Tutar }}</td>
            <td class="text-right">{{ Tahakkuk.ZamTutar }}</td>
            <td class="text-right">{{ Tahakkuk.Odenecek }}</td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <th colspan="3" class="text-right">MAKBUZ TOPLAMI</th>
            <th class="text-right">{{ data.T.T }}</th>
            <th class="text-right">{{ data.T.Z }}</th>
            <th class="text-right">{{ data.T.O }}</th>
          </tr>
          </tfoot>
        </table>
        <em v-if="data.Bilgi.Aciklama"><b>Makbuz Açıklama:</b> {{ data.Bilgi.Aciklama }}</em>
        <b v-if="data.Bilgi.BorcDurum">
          <hr class="m-1">
          <b>Güncel Borcunuz:</b> {{ data.Bilgi.Borc }} TL</b>
        <b v-if="!data.Bilgi.BorcDurum">
          <hr class="m-1">
          <i class="feather-thumbs-up"></i> Güncel borcunuz bulunmamaktadır. <br> <i class="feather-clock"></i>
          Ödemelerinizi düzenli yaptığınız için teşekkür ederiz.</b>

        <vrcode
          :value="data.Bilgi.Url"
          helpers="url"
          :options="{size: 100,level: 'L'}"
          logo="https://cdn.mudu.pro/Design/Qr.jpg"
        ></vrcode>
      </div>
      <div class="Bilgi">
        <table class="table">
          <thead>
          <tr>
            <th colspan="2" class="text-center">TAHSİLAT MAKBUZU</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>Ad Soyad</td>
            <td class="text-right">{{ data.Bilgi.AdSoyad }}</td>
          </tr>
          <tr>
            <td>Bina Adı</td>
            <td class="text-right">{{ data.Bilgi.BinaAdi }}</td>
          </tr>
          <tr>
            <td>Mesken Bilgi</td>
            <td class="text-right">{{ data.Bilgi.Kat }}. Kat {{ data.Bilgi.kNo }} Numara</td>
          </tr>
          <tr>
            <td>Makbuz No</td>
            <td class="text-right">{{ data.Bilgi.mNo }}</td>
          </tr>
          <tr>
            <td>Kasa</td>
            <td class="text-right">{{ data.Bilgi.Kasa }}</td>
          </tr>
          <tr>
            <td>Ödeme Tarihi</td>
            <td class="text-right">{{ data.Bilgi.oTarihi }}</td>
          </tr>
          <tr>
            <td>İşlem Zamanı</td>
            <td class="text-right">{{ data.Bilgi.iTarihi }}</td>
          </tr>
          <tr v-if="data.Bilgi.tZamDurum">
            <td>Tahsil Zam</td>
            <td class="text-right">{{ data.Bilgi.tZam }} TL</td>
          </tr>
          <tr v-if="data.Bilgi.tmKarDurum">
            <td>Hizmet Bedeli</td>
            <td class="text-right">{{ data.Bilgi.tmKar }} TL</td>
          </tr>
          <tr v-if="data.Bilgi.KomisyonDurum">
            <td>Pos Komisyonu</td>
            <td class="text-right">{{ data.Bilgi.Komisyon }} TL</td>
          </tr>
          <tr v-if="data.Bilgi.EmanetDurum">
            <td>Emanet</td>
            <td class="text-right">{{ data.Bilgi.Emanet }} TL</td>
          </tr>
          <tr v-if="data.BankaDokum">
            <td>Banka Referans No</td>
            <td class="text-right">{{ data.BankaDokum.Referans }}</td>
          </tr>
          <tr>
            <td>Ödenen</td>
            <td class="text-right"><b>{{ data.Bilgi.OdemeTutar }} TL</b></td>
          </tr>
          </tbody>
        </table>
        <small>{{ data.Bilgi.BinaAdi }} adına {{ data.Bilgi.Personel.AdSoyad }} tarafından tahsil edilmiştir.</small>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data', 'FontSize'],
  data() {
    return {
      windowRef: null,
    };
  },
  watch: {
    open(newOpen) {
      if (newOpen) {
        this.openPortal();
      } else {
        this.closePortal();
      }
    }
  },
  methods: {

    openPortal() {

      this.windowRef = window.open(
        "",
        "",
        "width=800,height=800,left=100,top=100"
      );
      this.windowRef.document.write('<html><head><title>Aidatım Yazıcı</title>' +
        '<link href="https://fonts.googleapis.com/css?family=Google+Sans:700,700i&amp;subset=latin-ext" rel="stylesheet">' +
        '<link rel="stylesheet" type="text/css" href="https://cdn.mudu.pro/Style/Print/Genel.css">' +
        '<link rel="stylesheet" type="text/css" href="https://cdn.mudu.pro/Style/Print/Makbuz.css?v1">' +
        '<style>body,table{font-size:' + this.FontSize + ' !important;}</style>' +
        '</head><body>');
      this.windowRef.document.body.appendChild(this.$el);
      this.windowRef.document.write('</body></html>');

      var is_chrome = function () {
        return Boolean(this.windowRef.chrome);
      }
      if (is_chrome) {
        setTimeout(() => {
        this.windowRef.print();
        }, 1000);
        setTimeout(() => {
          this.windowRef.close();
        }, 5000);
      } else {
        setTimeout(() => {
          this.windowRef.print();
        }, 1000);
        this.windowRef.close();
      }
      this.windowRef.addEventListener("beforeunload", this.closePortal);

    },
    closePortal() {

      if (this.windowRef) {
        this.windowRef.close();
        this.windowRef = null;
        this.$emit("close");
      }

    }
  },
  mounted() {
    if (this.data) {
      this.openPortal();
    }
  },
  beforeDestroy() {
    if (this.windowRef) {
      this.closePortal();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Yazdir/MakbuzYazdir.vue